// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 删除用户 删除用户接口 POST /bossApi/conference/core/user/v1/deleteUser */
export async function deleteBossUser(
  body: CoreAPI.DeleteUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/user/v1/deleteUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 核实本人创建用户的结果 返回用户标识，不返回初始密码；未找到不代表创建已失败 POST /bossApi/conference/core/user/v1/getCreateResult */
export async function getBossUserCreateResult(
  body: CoreAPI.UserCreateResultRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseUserCreateResultDTO>(
    '/bossApi/conference/core/user/v1/getCreateResult',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询用户 根据ID查询用户详情 POST /bossApi/conference/core/user/v1/getUser */
export async function getBossUser(
  body: CoreAPI.GetUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseUserVO>(
    '/bossApi/conference/core/user/v1/getUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取当前用户信息 根据当前登录态获取BOSS后台用户个人信息 POST /bossApi/conference/core/user/v1/getUserInfo */
export async function getBossUserInfo(
  body: CoreAPI.GetUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseUserVO>(
    '/bossApi/conference/core/user/v1/getUserInfo',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 新增用户 新增用户接口，返回用户ID和初始密码 POST /bossApi/conference/core/user/v1/insertUser */
export async function insertBossUser(
  body: CoreAPI.InsertUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseInsertUserVO>(
    '/bossApi/conference/core/user/v1/insertUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询用户列表 查询用户列表接口 POST /bossApi/conference/core/user/v1/listUser */
export async function listBossUser(
  body: CoreAPI.ListUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListUserVO>(
    '/bossApi/conference/core/user/v1/listUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 分页查询用户 分页查询用户接口 POST /bossApi/conference/core/user/v1/pageUser */
export async function pageBossUser(
  body: CoreAPI.PageUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseListUserVO>(
    '/bossApi/conference/core/user/v1/pageUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 重置密码 重置用户密码，返回临时密码 POST /bossApi/conference/core/user/v1/resetPassword */
export async function resetBossUserPassword(
  body: CoreAPI.ResetPasswordHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.CommonResponseResetPasswordVO>(
    '/bossApi/conference/core/user/v1/resetPassword',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 修改当前用户密码 BOSS后台用户校验原密码后修改当前登录人的密码 POST /bossApi/conference/core/user/v1/updatePassword */
export async function updateBossPassword(
  body: CoreAPI.UpdatePasswordHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/user/v1/updatePassword',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新用户 更新用户接口 POST /bossApi/conference/core/user/v1/updateUser */
export async function updateBossUser(
  body: CoreAPI.UpdateUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/user/v1/updateUser',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 更新当前用户信息 BOSS后台用户更新当前登录人的个人信息 POST /bossApi/conference/core/user/v1/updateUserInfo */
export async function updateBossUserInfo(
  body: CoreAPI.UpdateUserHttpRequest,
  options?: { [key: string]: any },
) {
  return request<CoreAPI.BaseResponse>(
    '/bossApi/conference/core/user/v1/updateUserInfo',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
